import Vue from 'vue';
import { SButton, SInput, SToggle, SLabel, SError } from "../../../components/ui-components";
import LabelNew from '../../../components/base/vacancies/label-new'
import ArticleEditor from '../../../components/base/article-editor/articleEditor'
import { formatTimeISO }  from "../../utils/utils"
import useVacancies from '../../domain/use-vacancies'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import PreloaderNew from '../../../components/preloader/preloader-new'

export default Vue.component('vacanciesCreate', {
  props: {
    action: { type: String, default: ''},
  },
  components: {
    SButton,
    SInput,
    SToggle,
    SLabel,
    SError,
    LabelNew,
    ValidationProvider,
    ValidationObserver,
    ArticleEditor,
    PreloaderNew
  },
  data() {
    return {
      formVacancies: {
        title: '',
        organization: '',
        city: '',
        description: '',
        full_description: '',
        salary_from: '',
        salary_to: '',
        sponsor_id: partnerId,
        status: true,
      },
      loading: false,
      configShortDescription: {
        editor: {
          // lang: 'ru',
          focus: true
        },
        plugins: ['reorder'],
      },
      configFullDescription: {
        editor: {
          // lang: 'ru',
          focus: true
        },
        plugins: ['reorder'],
      },
      balance: balance
    }
  },
  async created() {
    if (this.action === 'edit') {
      await this.getVacancies(vacancyId)
    }
  },
  methods: {
    formatTimeISO,
    async createVacancies() {
      this.loading = true
      try {
        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.formVacancies.status ? this.formVacancies.is_active = 1 : this.formVacancies.is_active = 0
          await useVacancies().createVacancies(this.formVacancies)
          location.href = '/vacancy/vacancies'
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }

    },
    async updateVacancies() {
      this.formVacancies.is_active = this.formVacancies.status ? true : false
      this.loading = true
      try {
        await useVacancies().updateVacancy(vacancyId, this.formVacancies)
        location.href = '/vacancy/vacancies'
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }

    },
    async getVacancies(idVacancies) {
      this.loading = true
      try {
        const res = await useVacancies().getVacancies(idVacancies)
        res.is_active === true ? res.status = true : res.status = false
        this.formVacancies = res
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    }
  }
});
